import { getCalendarEntry } from 'owa-calendar-cache';
import { getCalendars } from './getCalendars';

export function getCalendarsForCalendarGroup(userIdentity: string, parentGroupId: string) {
    const calendars = getCalendars().filter(item => {
        const calendarEntry = getCalendarEntry(item);
        return (
            calendarEntry &&
            calendarEntry.ParentGroupId === parentGroupId &&
            item.id.mailboxInfo.userIdentity === userIdentity
        );
    });

    return calendars;
}
